export default "__VITE_ASSET__2105288c__"